import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToFocusChange = (
    focusChange$: Observable<boolean>,
    frameStore: IFrameStore
): Subscription =>
    focusChange$
        .subscribe((isFocused) => isFocused ?
            frameStore.actions.focus() :
            frameStore.actions.blur()
        );

export default subscribeToFocusChange;